var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 103,
    viewBox: "0 0 128 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2001 11.1807H24.5201C17.5008 11.1807 13.9911 11.1807 11.3101 12.5468C8.95179 13.7484 7.03444 15.6657 5.83287 18.0241C4.4668 20.7051 4.4668 24.2148 4.4668 31.2341V78.8607C4.4668 85.88 4.4668 89.39 5.83287 92.0709C7.03444 94.429 8.95179 96.3466 11.3101 97.5479C13.9911 98.9141 17.5008 98.9141 24.5201 98.9141H97.2135C104.233 98.9141 107.743 98.9141 110.424 97.5479C112.782 96.3466 114.699 94.429 115.901 92.0709C117.267 89.39 117.267 85.88 117.267 78.8607V33.1152M4.4668 29.9807L38.6224 52.7513C46.66 58.1093 50.6791 60.7889 55.0225 61.8304C58.864 62.751 62.8696 62.751 66.7111 61.8304C71.0545 60.7889 91.8996 41.6054 99.9372 36.2474M123.533 20.5807C123.533 29.2332 116.519 36.2474 107.867 36.2474C99.2144 36.2474 92.2001 29.2332 92.2001 20.5807C92.2001 11.9283 99.2144 4.91406 107.867 4.91406C116.519 4.91406 123.533 11.9283 123.533 20.5807Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.ca877f9aba631ec335236926ed021566.svg";
export { ForwardRef as ReactComponent };